import { Asterisk } from "lucide-react";

const ITEMS = [
  "Agri & Food Commodities",
  "Organic Cotton Textiles",
  "Handcrafted Artisanal Goods",
  "Industrial Components",
  "Lab-Tested Shipments",
  "40+ Countries Served",
  "Private-Label Ready",
  "Docs-Ready Dispatch",
];

function Row({ hidden = false }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-7 font-display text-sm font-semibold uppercase tracking-[0.2em] text-forest sm:text-base">
            {item}
          </span>
          <Asterisk className="h-5 w-5 shrink-0 text-gold" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-forest/10 bg-sage py-5"
    >
      <div className="marquee-track flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
